__turbopack_context__.v({
  "a": "styles-module__imUJYa__a",
  "b": "styles-module__imUJYa__b",
  "c": "styles-module__imUJYa__c",
  "d": "styles-module__imUJYa__d",
  "e": "styles-module__imUJYa__e",
  "f": "styles-module__imUJYa__f",
  "g": "styles-module__imUJYa__g",
  "h": "styles-module__imUJYa__h",
  "i": "styles-module__imUJYa__i",
  "j": "styles-module__imUJYa__j",
  "k": "styles-module__imUJYa__k",
  "pattern": "styles-module__imUJYa__pattern",
  "variantB": "styles-module__imUJYa__variantB",
  "variantC": "styles-module__imUJYa__variantC",
});
